/**
 * Pagination constants used across the application
 */
export const PAGINATION = {
  /** Default number of items per page */
  DEFAULT_PAGE_SIZE: 20,
  /** Available page size options */
  PAGE_SIZE_OPTIONS: [20, 50, 100],
} as const;
